import { render } from "./catalogue.html?vue&type=template&id=f73aa5f0&external"
import script from "./catalogue.js?vue&type=script&lang=js&external"
export * from "./catalogue.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__